import type { Guide } from '@/hooks/use-alignment-guides';

export function AlignmentGuides({ guides }: { guides: ReadonlyArray<Guide> }): JSX.Element {
  return (
    <>
      {guides.map((g, i) => (
        <div
          key={`${g.kind}-${i}`}
          data-testid="alignment-guide"
          data-guide-kind={g.kind}
          style={{
            position: 'absolute',
            background: '#ec4899',
            pointerEvents: 'none',
            ...(g.kind === 'vertical'
              ? { left: g.x, top: 0, bottom: 0, width: 1 }
              : { top: g.y, left: 0, right: 0, height: 1 }),
          }}
        />
      ))}
    </>
  );
}
